export default "__VITE_ASSET__C2NaKJ$Q__"